<div id="add-booking" class="modalinner">
    <div class="modal-header">
      <h2 class="modal-title" id="myModalLabel" translate>lblBlockMechanic</h2>
      <button type="button" class="close" (click)="activeModal.close()" aria-label="Center Align"><span
          aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body">
  
      <div class="af-form-group">
        <div class="row">
          <div class="col-4">
            <div class="af-form-group">
              <label translate>lblMechanic</label>
              <div class="lbl-info">
                {{mechanicName}}
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="af-form-group">
              <label translate>lblEfficiency</label>
              <div class="lbl-info">
                {{mechanicEfficiency}} %
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="af-form-group">
              <label translate>lblDealerName</label>
              <div class="lbl-info">
                {{dealerName}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card pad15">
        <div class="d-flex" style="margin-top:-10px;">
          <div style="width: 40%;" class="cst-picker" #rentalCarBookingCalendar>
            <input appAfDatepicker [isInline]="true" [dateTime]="false" autocomplete="off"
              [disabledDates]="unavailableDateValues" class="datePicker" id="rentalCarBookingCalendarId"
              [disabledDates]="disableDatesOfCalender" name="EndDate" type="text" [defaultDate]="mechanicDateFormat"
              [startDate]="calenderStartDate" [endDate]="" [value]="mechanicDateFormat" (OnSelect)="OnDateChanged($event)"
              (onChangeMonthYear)="MonthChangeFiredForStartDate($event)" [formatDate]="formatDate">
          </div>
          <div style="width: 60%">
            <div style="margin-left: 40px; margin-top: -15px;">
              <div class="row">
                <div class="time d-flex mt-5">
                  <div class="start">
                    <label class="duration"><span translate>lblDuration</span>(HH:MM)</label>
                    <div class="d-flex align-items-center">
                      <input type="number" class="duration-hr form-control" [(ngModel)]="durationHours" pattern="^\d{2}$"
                        maxlength="2" (keyup)="MoveToDurationMinute($event)" (blur)="OnStartTimeChange()"
                        (blur)="CheckHourDuration()">
                      <span class="p-2"> : </span>
                      <input type="number" class="duration-min form-control" [(ngModel)]="durationMinutes"
                        pattern="^\d{2}$" maxlength="2" #durationminuteInput (blur)="OnStartTimeChange()"
                        (blur)="CheckMinuteDuration()">
                    </div>
                  </div>
                </div>
              </div>
              <div class="time d-flex mt-5">
                <div class="start">
                  <label><span translate>lblStart</span>(HH:MM)</label>
                  <div class="d-flex align-items-center">
                    <input type="number" class="start-1" [(ngModel)]="startHours" maxlength="2"
                      (keyup)="MoveToMinute($event)" (blur)="OnStartTimeChange()">
                    <span> : </span>
                    <input type="number" class="start-2" [(ngModel)]="startMin" maxlength="2" #minuteInput
                      (blur)="OnStartTimeChange()">
                  </div>
                </div>
              </div>
              <div class="time d-flex mt-5">
                <div class="start">
                  <label translate>lblStartDateTime</label>
                  <div>
                    <p class="cd-data-text" id="startDateTimeLabel" *ngIf="!isStartTime"> - </p>
                    <p class="cd-data-text" id="startDateTimeLabel" *ngIf="isStartTime">
                      {{dateValue |date:'shortDate'}}
                      {{timeValue}}
                    </p>
                  </div>
                </div>
                <div class="end">
                  <label translate>lblEndDateTime</label>
                  <div>
                    <p class="cd-data-text" id="endDateTimeLabel" *ngIf="!isEndTime"> -</p>
                    <p class="cd-data-text" id="startDateTimeLabel" *ngIf="isEndTime">
                      {{dateValue |date:'shortDate'}}
                      {{endTimeValue }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="time d-flex mt-5">
                <div class="lbl-info">
                  <label translate>lblReason</label>
                  <input type="text" id="template-edit-model" name="model"  
                      class="form-control" [(ngModel)]="reason" 
                      maxlength="1000">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal-footer">
      <a href="javascript:void(0);" class="btn btn-primary mr-sm-2" (click)="SaveMechanicBlockTime()"><span
          translate>lblConfirm</span></a>
      <a href="javascript:void(0);" class="btn btn-secondary" (click)="activeModal.close()"><span
          translate>lblCancel</span></a>
    </div>
  </div>